import { defineMutators } from '@rocicorp/zero';
import { trackMutators } from './track/mutators';
import { blockMutators, workoutStatusMutators } from './block/mutators';

export const mutators = defineMutators({
  track: trackMutators,
  block: blockMutators,
  workoutStatus: workoutStatusMutators,
});

export {
  zCreateTrackArgs,
  type CreateTrackArgs,
  zDeleteTrackArgs,
  type DeleteTrackArgs,
  zArchiveTrackArgs,
  type ArchiveTrackArgs,
  type TrackMutatorCtx,
} from './track/mutators';

export {
  type PublishBlockArgs,
  type PrintBlockArgs,
  type DeletePrintTaskArgs,
  type CancelBlockWorkoutArgs,
  type UpdateAthleteWorkoutStatusArgs,
  type BlockMutatorCtx,
  type WorkoutStatusMutatorCtx,
} from './block/mutators';
